module.exports = __webpack_public_path__ + "fontello.svg?2b896dddaec30364f1ea7af391899eca";


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/icons/font/fontello.svg?20907657
// module id = 426
// module chunks = 0